import axios from 'axios';

const state = {
    data: null,
    error: null,
};

const mutations = {
    setData(state, data) {
        state.data = data;
    },
    setError(state, error) {
        state.error = error;
    },
};

const actions = {
    fetchData({ commit }) {
        axios.get('https://api.example.com/data')
            .then(response => {
                commit('setData', response.data);
            })
            .catch(error => {
                commit('setError', error);
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};